export const messages = {
  en: {
    aStaffDetailList: {
      staffInfo: 'Staff Information',
      back: 'Back',
      edit: 'Edit',
      resetPwd: 'Reset Password',
      staffId: 'Staff ID',
      userName: 'Name',
      idCard: 'ID Card',
      tel: 'Phone',
      sex: 'Gender',
      male: 'Male',
      female: 'Female',
      address: 'Address',
      orgPrivilege: 'Organization Privilege',
      community: 'Community',
      loadError: 'Failed to load staff information',
      resetSuccess: 'Password reset successful',
      editSuccess: 'Staff information updated',
      addCommunitySuccess: 'Community added successfully',
      deleteCommunitySuccess: 'Community removed successfully'
    },
    "staffDetailOrgPrivilege": {
      "relatedOrg": "Related Organization",
      "org": "Organization",
      "position": "Position",
      "relatedRole": "Related Roles",
      "staffPrivilege": "Staff Privileges",
      "loadOrgsError": "Failed to load organizations",
      "loadRolesError": "Failed to load roles",
      "loadPrivilegesError": "Failed to load privileges"
    },
    "aStaffDetailCommunitys": {
      "relateCommunity": "Relate Community",
      "staffName": "Staff Name",
      "staffId": "Staff ID",
      "communityId": "Community ID",
      "communityName": "Community Name",
      "operation": "Operation",
      "delete": "Delete",
      "loadError": "Failed to load community data"
    },
    "addAStaffCommunity": {
      "community": "Community",
      "searchPlaceholder": "Enter community name",
      "communityId": "Community ID",
      "communityName": "Community Name",
      "communityAddress": "Community Address",
      "cancel": "Cancel",
      "submit": "Submit",
      "loadError": "Failed to load community data",
      "selectCommunity": "Please select at least one community",
      "addSuccess": "Community added successfully",
      "addError": "Failed to add community"
    },
    "deleteAStaffCommunity": {
      "confirmOperation": "Confirm Your Operation",
      "confirmDelete": "Are you sure you want to delete this community?",
      "cancel": "Cancel",
      "confirm": "Confirm Delete",
      "deleteSuccess": "Community deleted successfully",
      "deleteError": "Failed to delete community"
    }
  },
  zh: {
    aStaffDetailList: {
      staffInfo: '员工信息',
      back: '返回',
      edit: '修改',
      resetPwd: '重置密码',
      staffId: '编号',
      userName: '名称',
      idCard: '身份证',
      tel: '手机',
      sex: '性别',
      male: '男',
      female: '女',
      address: '住址',
      orgPrivilege: '组织权限',
      community: '小区',
      loadError: '加载员工信息失败',
      resetSuccess: '密码重置成功',
      editSuccess: '员工信息修改成功',
      addCommunitySuccess: '小区关联成功',
      deleteCommunitySuccess: '小区删除成功'
    },
    "staffDetailOrgPrivilege": {
      "relatedOrg": "关联组织",
      "org": "组织",
      "position": "岗位",
      "relatedRole": "关联角色",
      "staffPrivilege": "员工权限",
      "loadOrgsError": "加载组织失败",
      "loadRolesError": "加载角色失败",
      "loadPrivilegesError": "加载权限失败"
    },
    "aStaffDetailCommunitys": {
      "relateCommunity": "关联小区",
      "staffName": "员工名称",
      "staffId": "员工编号",
      "communityId": "小区编号",
      "communityName": "小区名称",
      "operation": "操作",
      "delete": "删除",
      "loadError": "加载小区数据失败"
    },
    "addAStaffCommunity": {
      "community": "小区",
      "searchPlaceholder": "输入小区名称",
      "communityId": "小区ID",
      "communityName": "小区名称",
      "communityAddress": "小区地址",
      "cancel": "取消",
      "submit": "提交",
      "loadError": "加载小区数据失败",
      "selectCommunity": "请至少选择一个小区",
      "addSuccess": "小区关联成功",
      "addError": "小区关联失败"
    },
    "deleteAStaffCommunity": {
      "confirmOperation": "请确认您的操作",
      "confirmDelete": "确定删除隶属小区？",
      "cancel": "点错了",
      "confirm": "确认删除",
      "deleteSuccess": "小区删除成功",
"deleteError": "小区删除失败"
    }
  },
  'zh-TW': {
    aStaffDetailList: {
      staffInfo: '員工信息',
      back: '返回',
      edit: '修改',
      resetPwd: '重置密碼',
      staffId: '編號',
      userName: '名稱',
      idCard: '身份證',
      tel: '手機',
      sex: '性別',
      male: '男',
      female: '女',
      address: '住址',
      orgPrivilege: '組織權限',
      community: '小區',
      loadError: '載入員工信息失敗',
      resetSuccess: '密碼重置成功',
      editSuccess: '員工信息修改成功',
      addCommunitySuccess: '小區關聯成功',
      deleteCommunitySuccess: '小區刪除成功'
    },
    "staffDetailOrgPrivilege": {
      "relatedOrg": "關聯組織",
      "org": "組織",
      "position": "崗位",
      "relatedRole": "關聯角色",
      "staffPrivilege": "員工權限",
      "loadOrgsError": "載入組織失敗",
      "loadRolesError": "載入角色失敗",
      "loadPrivilegesError": "載入權限失敗"
    },
    "aStaffDetailCommunitys": {
      "relateCommunity": "關聯小區",
      "staffName": "員工名稱",
      "staffId": "員工編號",
      "communityId": "小區編號",
      "communityName": "小區名稱",
      "operation": "操作",
      "delete": "刪除",
      "loadError": "載入小區數據失敗"
    },
    "addAStaffCommunity": {
      "community": "小區",
      "searchPlaceholder": "輸入小區名稱",
      "communityId": "小區ID",
      "communityName": "小區名稱",
      "communityAddress": "小區地址",
      "cancel": "取消",
      "submit": "提交",
      "loadError": "載入小區數據失敗",
      "selectCommunity": "請至少選擇一個小區",
      "addSuccess": "小區關聯成功",
      "addError": "小區關聯失敗"
    },
    "deleteAStaffCommunity": {
      "confirmOperation": "請確認您的操作",
      "confirmDelete": "確定刪除隸屬小區？",
      "cancel": "點錯了",
      "confirm": "確認刪除",
      "deleteSuccess": "小區刪除成功",
      "deleteError": "小區刪除失敗"
    }
  }
}